"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

/**
 * @param {Object} origin
 * @param {Object} update
 */

function pickDiff(origin, update) {
  var result = {};

  Object.keys(update).forEach(function (key) {
    if (origin.hasOwnProperty(key) && origin[key] === update[key]) {
      return;
    }

    result[key] = update[key];
  });

  return result;
}

exports.default = pickDiff;